import React from 'react';
import { Dropdown, Form } from 'react-bootstrap';

function LabLocationDropdown({ labLocations, selectedLabLocations, handleLabLocationChange, setSelectedLabLocations }) {
    
    return (
        <Dropdown className="d-inline-block">
            <Dropdown.Toggle className="p-0" id="statusFilterDropdown">
                Lab Locations
            </Dropdown.Toggle>

            <Dropdown.Menu>
                <form>
                    {labLocations.map((labLocation) => {
                        const isChecked = selectedLabLocations.includes(labLocation.id);
                        return (
                            <Form.Group controlId={labLocation.id} key={labLocation.id}>
                                <Form.Check
                                    type="checkbox"
                                    label={labLocation.name}
                                    checked={isChecked}
                                    onChange={() => handleLabLocationChange(labLocation.id)}
                                />
                            </Form.Group>
                        );
                    })}
                </form>
                <div>
                    <input
                        type="button"
                        value="Clear All"
                        className="btn btn-link"
                        onClick={() => setSelectedLabLocations([])}
                    />
                </div>
            </Dropdown.Menu>
        </Dropdown>
    );
}

export default LabLocationDropdown;
